import { render, staticRenderFns } from "./TerapiasList.vue?vue&type=template&id=f950905e"
import script from "./TerapiasList.vue?vue&type=script&lang=js"
export * from "./TerapiasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports